"use client";
//#region packages/@mantine/core/src/components/CloseButton/CloseButton.module.css
var CloseButton_module_default = {
	"root": "m_86a44da5",
	"root--subtle": "m_220c80f2"
};
//#endregion
export { CloseButton_module_default as default };

//# sourceMappingURL=CloseButton.module.mjs.map